export default [
    {
        id: 1,
        bde_code: 'A23',
        name_ca: 'Dades d\'oferta',
        name_en: 'Offer data',
        name_es: 'Datos de oferta'
    },
    {
        id: 2,
        bde_code: 'A22',
        name_ca: 'Transaccions recents',
        name_en: 'Recent transactions',
        name_es: 'Transacciones recientes'
    }
]





// WEBPACK FOOTER //
// ./src/options/ad_data_types.js